<template>
    <div class="card card-round shadow dashboard-widget dashboard-widget--boq dashboard-widget--budget-breakdown">
        <div class="card-header">
            <h6 class="fw-bold mb-0 dashboard-widget__title">
                <span class="dashboard-widget__icon" v-html="sidebarSvg.boq"></span>
                <span>{{ $t('Total Budget Breakdown') }}</span>
            </h6>
        </div>
        <div class="card-body">
            <div class="text-center" v-if="data.sections.length==0">
                <div class="alert alert-outline-primary d-flex align-items-center" role="alert">
                    <i class="fas fa-info-circle fa-2x me-2"></i>  
                    <div>
                        {{ $t('No Approved Bill Of Quantities Yet to Show Breakdown') }}
                    </div>
                </div>
            </div>
            <div class="budget-breakdown__content" v-if="data.sections.length!=0">
                <div class="budget-breakdown__chart-wrap">
                    <DoughnutChart :data="doughnutData"></DoughnutChart>
                    <div class="budget-breakdown__center-label">
                        <strong>{{projectInfo.currencyId?.sign}}{{ ReformatNumber(data.sum) }}</strong>
                        <span>{{ $t('Total Budget') }}</span>
                    </div>
                </div>
                <div class="budget-breakdown__legend">
                    <div class="budget-breakdown__legend-item" v-for="(item,key) in data.sections" :key="key">
                        <span class="budget-breakdown__dot" :style="'background:' + colors[key % colors.length]"></span>
                        <span class="budget-breakdown__name">{{ item.name }}</span>
                        <span class="budget-breakdown__percent">{{ GetPercent(item.amount) }}%</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {DashboardGetProjectBudgetBreakdown} from '@/actions/projectActions.js'
import {ReformatNumber} from '../../helpers/utilities.js'
import DoughnutChart from '@/components/layout/DoughnutChart.vue'
import { sidebarSvg } from '@/components/deluxe/DeluxeSidebar.vue'
export default {
    name : 'NetCashPosition',
    props : ['projectInfo'],
    components : {
        DoughnutChart
    },
    data(){
        return {
            colors : ['#94d13d','#6f58e9','#2d99fe','#2ddac1','#15a2fd','#dcd96c',
                        '#9c2349','#784975','#582da8', '#FFC600','#00AAF3','#50D691'],
            doughnutData : {
                labels: [],
                datasets: [],
            },
            data : { 
                sections : [],
                sum : 0
            },
            sidebarSvg
            
        }
    },
    mounted : async function(){
        const self = this

        self.data = await DashboardGetProjectBudgetBreakdown(self.projectInfo._id)
        if(!self.data)
            return
        self.doughnutData.labels  = self.data.sections.map(u=>u.name)
        self.doughnutData.datasets = [
            {
                data : self.data.sections.map(u=>{
                    return Math.round((u.amount / self.data.sum)* 100)
                }),
                backgroundColor : ['#94d13d','#6f58e9','#2d99fe','#2ddac1','#15a2fd','#dcd96c',
                        '#9c2349','#784975','#582da8', '#FFC600','#00AAF3','#50D691']
            }
        ]
    },
    methods :{
        ReformatNumber,
        GetPercent(amount) {
            const sum = Number(this.data.sum) || 0
            if (!sum) return 0
            return Math.round((Number(amount) / sum) * 1000) / 10
        },
    }
    
} 
</script>
